import { render, staticRenderFns } from "./SAvatars.vue?vue&type=template&id=381cbe79&scoped=true&lang=pug"
import script from "./SAvatars.vue?vue&type=script&setup=true&lang=ts"
export * from "./SAvatars.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SAvatars.vue?vue&type=style&index=0&id=381cbe79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381cbe79",
  null
  
)

export default component.exports